import { render, staticRenderFns } from "./AllDy.vue?vue&type=template&id=33a64670&scoped=true"
import script from "./AllDy.vue?vue&type=script&lang=js"
export * from "./AllDy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a64670",
  null
  
)

export default component.exports